import * as R from 'ramda';

export default function uniqueEndnoteTagDirective(
  $q,
  pmSharedModelService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, el, attrs, ctrl) {
    const policyDocumentId = attrs.policyDocumentId || -1;
    const endnoteId = attrs.endnoteId || -1;

    ctrl.$asyncValidators.uniqueEndnoteTag = (modelValue) => {
      if (ctrl.$isEmpty(modelValue)) {
        // Consider empty model valid. This is probably the view's initial load.
        return $q.resolve();
      }

      const displayName = _getDisplayName(modelValue);

      if (!displayName) {
        // Nothing to check, move along... move along...
        return $q.resolve();
      }

      const def = $q.defer();

      // We have a tag, so see if it exists
      pmSharedModelService.checkEndnoteTagExists(policyDocumentId, endnoteId,
        displayName).then((response) => {
        if (!response.result) {
          def.resolve();
        } else {
          def.reject();
        }
      }).catch(() => def.reject());

      return def.promise;
    };
  }

  function _getDisplayName(modelValue) {
    switch (R.type(modelValue)) {
      case 'Object':
        return modelValue.displayName;
      default:
        // Assume modelValue is a string
        return modelValue;
    }
  }
}

export const name = 'pmUniqueEndnoteTag';

uniqueEndnoteTagDirective.$inject = [
  '$q',
  'pmSharedModelService'
];
